/* eslint-disable camelcase */
import axios from 'axios';
import { ROOT_URL_V2, getCSRFToken } from '../config';
import { encodeQueryData } from '../api/DataHandlers';

// eslint-disable-next-line import/no-cycle
import { errorMessage } from './ClientData';
import { updateLoading } from './Loading';

export const UPDATE_FIELD = 'UPDATE_FIELD';
export const DELETE_FIELD = 'DELETE_FIELD';
export const SET_ROLE_EXTRA = 'SET_ROLE_EXTRA';
export const UPDATE_ROLE_EXTRA = 'UPDATE_ROLE_EXTRA';
export const SET_PAYGRADE = 'SET_PAYGRADE';
export const SET_START_TIME = 'SET_START_TIME';
export const SET_JOB_REQUESTS = 'SET_JOB_REQUESTS';
export const SET_DISCOUNT = 'SET_DISCOUNT';
export const APPEND_JOB_REQUESTS = 'APPEND_JOB_REQUESTS';

/* ----------------------- Update Booking Request Data -----------------------*/

export function updateField(field, data) {
    return {
        type: 'UPDATE_FIELD',
        payload: { field, data },
    };
}

export function deleteField(field) {
    return {
        type: DELETE_FIELD,
        payload: field,
    };
}

export function setRoleExtra(role, data) {
    return {
        type: 'SET_ROLE_EXTRA',
        payload: { role, data },
    };
}

export function updateRoleExtra(role, field, data) {
    return {
        type: 'UPDATE_ROLE_EXTRA',
        payload: { role, field, data },
    };
}

/* ----------------------- Get Paygrade Data -----------------------*/

export function fetchPaygradeData(data) {
    return {
        type: 'SET_PAYGRADE',
        payload: data,
    };
}

export function fetchPaygradeAsync(
    service_key,
    start_time,
    date,
    roleExtras = null,
    callback = null,
) {
    if (!start_time || !date)
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return () => {};

    const startDateTime = new Date(`${date}T${start_time}`).toISOString();

    let queryData = {
        service: service_key,
        start: startDateTime,
    };

    if (roleExtras !== null) {
        const filteredRoleExtras = Object.fromEntries(
            Object.entries(roleExtras).filter(([, value]) => !!value)
        );
        queryData = { ...queryData, ...filteredRoleExtras };
    }

    const url = `${ROOT_URL_V2}paygrades/?${encodeQueryData(queryData)}`;

    return dispatch => {
        dispatch(updateLoading('paygrade', true));
        axios({
            method: 'GET',
            url,
        })
            .then(response => {
                dispatch(fetchPaygradeData(response.data.content));
                dispatch(updateLoading('paygrade', false));
                if (callback) {
                    callback(response);
                }
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log('fetchPaygradeAsync-error', error);
                if (callback) {
                    callback(error.response);
                }
                dispatch(updateLoading('paygrade', false));
            });
    };
}

/* ----------------------- Update voucher -----------------------*/

export function setDiscount(data) {
    return {
        type: SET_DISCOUNT,
        payload: data,
    };
}

export function getEstimatedPrice(voucherCode, jobRequestIds) {
    return dispatch => {
        const jobRequestId = jobRequestIds[0];
        if (jobRequestId) {
            axios
                .get(
                    `${ROOT_URL_V2}vouchers/${encodeURIComponent(
                        voucherCode,
                    )}/estimate/?jobrequest=${jobRequestId}`,
                )
                .then(response => {
                    dispatch(setDiscount(response.data.content));
                })
                .catch(error => {
                    // eslint-disable-next-line no-console
                    console.log(error);
                });
        }
    };
}

/* ----------------------- Get Nearest StartTime Request -----------------------*/

export function minStartTime(data) {
    return {
        type: 'SET_START_TIME',
        payload: data,
    };
}

export function minStartTimeAsync(data) {
    const params = encodeQueryData(data);

    return dispatch => {
        axios({
            method: 'GET',
            url: `${ROOT_URL_V2}paygrades/minimal-start/${params ? `?${params}` : ''}`,
        })
            .then(response => {
                dispatch(minStartTime(response.data.content));
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error.response);
            });
    };
}

/* ----------------------- Post Booking Request -----------------------*/

export function setBookingRequest(data) {
    return {
        type: 'SET_JOB_REQUESTS',
        payload: data,
    };
}

export function appendBookingRequest(data) {
    return {
        type: 'APPEND_JOB_REQUESTS',
        payload: data,
    };
}

export function fetchBookingRequestSeriesAsync(series, nextPage = null) {
    return dispatch => {
        dispatch(updateLoading('booking', true));
        const url = nextPage || `${ROOT_URL_V2}jobs/?series=${series}`;
        if (!nextPage) {
            dispatch(setBookingRequest([]));
        }

        axios({
            method: 'GET',
            url,
        })
            .then(response => {
                dispatch(appendBookingRequest(response.data.content));
                if (response.data.meta.next) {
                    dispatch(
                        fetchBookingRequestSeriesAsync(
                            series,
                            response.data.meta.next,
                        ),
                    );
                } else {
                    dispatch(updateLoading('booking', false));
                }
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error);
                dispatch(updateLoading('booking', false));
            });
    };
}

export function sendBookingRequestAsync(data, completion) {
    return dispatch => {
        dispatch(updateLoading('booking', true));
        axios({
            method: 'POST',
            url: `${ROOT_URL_V2}jobs/`,
            data,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                dispatch(setBookingRequest(response.data.content));
                completion(response.data, undefined);
                dispatch(updateLoading('booking', false));
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error);
                completion(undefined, error);
                dispatch(updateLoading('booking', false));
            });
    };
}

export function postPaymentAsync(data, completion) {
    return dispatch => {
        dispatch(updateLoading('postPayment', true));
        dispatch(errorMessage('confirmJob', null));
        axios({
            method: 'POST',
            url: `${ROOT_URL_V2}jobs/pay/`,
            data,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                completion(response.data, undefined);
            })
            .catch(error => {
                const msg =
                    error && error.response.data.meta.detail
                        ? error.response.data.meta.detail
                        : 'Sorry, there was an issue taking payment.';
                dispatch(errorMessage('confirmJob', msg));
                completion(undefined, error.response);
                dispatch(updateLoading('postPayment', false));
            });
    };
}
